export const UserRole={
    PortalAdmin:1,
    CompanyAdmin: 2,
    SalesExecutive: 3,
    SalesManager:4,
    Lead:5,
}   

